import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, translate, formatDateToPtbr, getUserNameToName } from '../../../../utils/util';
import * as containerAction from '../../../../actions/containerAction';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';

const ContainerList = (props) => {
    const [containers, setContainers] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 5, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [filter, setFilter] = useState({ internal: false });

    useEffect(() => {
        if (props.filters) {
            setFilter(props.filters);
        }

        if ((props.containerStatus?.length ?? 0) === 0) props.getStatusContainer();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setContainers(props.containers?.items || []);
        // eslint-disable-next-line
    }, [props?.containers?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getContainers({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                header: 'Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerTypeName',
                header: 'Tipo',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerSizeName',
                header: 'Tamanho',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const redirectChangeStatus = (item) => {

        props.history.push({
            state: {
                dataParams: item,
            },
            pathname: './changestatus'
        });
    }

    const configActions = () => [
        {
            function: (row) => (
                (
                    <i
                        className="mdi mdi-36px mdi-arrow-right-bold gray-text"
                        title="Alterar Status Container"
                        onClick={() => {
                            redirectChangeStatus(row);
                        }}
                        style={{ fontSize: "1.85rem", cursor: "pointer", color: "green" }} >
                    </i>
                ))
        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Container" }} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12" >
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="name"
                                                name='name'
                                                label="Num. Container / MVM ou Viagem"

                                                type="text"
                                                value={filter?.name || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        {
                                            <div className="input-field no-padding col s12">
                                                <SelectNew
                                                    id="status"
                                                    name="status"
                                                    required
                                                    value={filter?.status || ''}
                                                    change={onChange}
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label="Status"
                                                    data={props.containerStatus?.map((x) => ({ id: x.id, text: x.description }))}
                                                />
                                            </div>
                                        }
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <Table
                    totalPages={props.containers?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={containers}
                    actions={configActions()} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        containers: state.containerReducer.containers,
        filters: state.containerReducer.printFilters,
        containerStatus: state.containerReducer.containerStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainers: (filter) => {
            dispatch(ContainerService.getContainerPaged(filter));
        },
        setContainer: (container) => {
            dispatch(containerAction.setContainer(container));
        },
        setContainerFilters: (filters) => {
            dispatch(containerAction.setContainerFilters(filters));
        },
        deleteContainer: (containerId, callback) => {
            dispatch(ContainerService.deleteContainer(containerId, callback));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerCsv(filter, callback));
        },
        getContainerTypes: (filter) => {
            dispatch(ContainerService.getContainerTypes(filter));
        },
        getContainerSizes: (filter) => {
            dispatch(ContainerService.getContainerSizes(filter));
        },
        getStatusContainer: (filter) => {
            dispatch(ContainerService.getStatusContainer(filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerList));
